export default __webpack_public_path__ + "static/media/Aline.a5491efd.jpg";